import React, { ChangeEvent } from 'react';
import { FormField } from 'mesh-component-library';
import { OnEnter } from '../../../redux/hooks/useOnEnter';

export interface Props {
    className?: string;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
    placeholder: string | undefined;
    label: string | undefined;
    value: string;
    onEnterPress: OnEnter;
    onClear: VoidFunction;
    inputId: string;
    fieldError: boolean;
    helpText?: string;
    maxLength: number;
}

export const ClaimDataField: React.FC<Props> = ({
    className,
    label,
    onChange,
    placeholder,
    value,
    onEnterPress,
    onClear,
    inputId,
    fieldError,
    helpText,
    maxLength,
}) => {
    return (
        <div data-testid="validation-form__input-container" className={className}>
            <FormField className = {"form-field-input"}
                affixRight={
                    value
                        ? [
                              {
                                  hollow: true,
                                  icon: 'cross',
                                  onButtonClick: onClear,
                                  ariaLabel: 'clear',
                              },
                          ]
                        : undefined
                }
                data-testid={inputId}
                id={inputId}
                label={label}
                onChange={onChange}
                placeholder={placeholder}
                value={value}
                onKeyPress={onEnterPress}
                hasError={fieldError}
                helpText={helpText}
                maxLength={maxLength}
            />
        </div>
    );
};
